// extracted by mini-css-extract-plugin
export default {"notifs_container":"account_notifs_notifs_container__js3nT"};